/* eslint-disable @typescript-eslint/no-explicit-any */

const getValueByPath = (obj: any, path: string): any => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

export const uniqBy = <T>(array: T[], iteratee: ((item: T) => any) | string): T[] => {
  const seen = new Set<any>();
  const result: T[] = [];

  for (const item of array) {
    const key = typeof iteratee === 'function' ? iteratee(item) : getValueByPath(item, iteratee);

    if (!seen.has(key)) {
      seen.add(key);
      result.push(item);
    }
  }

  return result;
};

export const keyBy = <T>(
  array: T[],
  iteratee: ((item: T) => string | number) | string,
): Record<string, T> => {
  const result: Record<string, T> = {};

  for (const item of array) {
    const key = typeof iteratee === 'function' ? iteratee(item) : getValueByPath(item, iteratee);

    if (key !== null) {
      result[String(key)] = item;
    }
  }

  return result;
};

export const groupBy = <T>(items: T[], grouper: (item: T) => string) => {
  const groups: { [key: string]: T[] } = {};

  items.forEach(item => {
    const group = grouper(item);
    if (!groups[group]) {
      groups[group] = [item];
    } else {
      groups[group].push(item);
    }
  });

  return groups;
};
